import { render, staticRenderFns } from "./ViewCamera2.vue?vue&type=template&id=37952a8a&scoped=true&"
import script from "./ViewCamera2.vue?vue&type=script&lang=js&"
export * from "./ViewCamera2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37952a8a",
  null
  
)

export default component.exports